import { SDK } from "@ringcentral/sdk";

let rcsdk = null;

export const initializeRingCentralSDK = () => {
  try {
    const storedData = localStorage.getItem("ringCentralIntegration");

    if (!storedData) {
      console.warn("RingCentral integration details not found");
      return null;
    }

    const integrationDetails = JSON.parse(storedData);

    const {
      attribute_1: clientId,
      attribute_2: clientSecret,
    } = integrationDetails;

    if (!clientId || !clientSecret) {
      console.error("Missing RingCentral credentials");
      return null;
    }

    const redirectUri =
      process.env.REACT_APP_RINGCENTRAL_REDIRECT_URI;

    if (!redirectUri) {
      console.error("Missing RingCentral redirect URI");
      return null;
    }

    rcsdk = new SDK({
      server: "https://platform.ringcentral.com",
      clientId,
      clientSecret,
      redirectUri,
    });

    return rcsdk;
  } catch (error) {
    console.error(
      "Failed to initialize RingCentral SDK",
      error
    );

    return null;
  }
};

export const platform = () => {
  if (!rcsdk) {
    initializeRingCentralSDK();
  }

  if (!rcsdk) {
    return null;
  }

  return rcsdk.platform();
};

// Initialize SDK
initializeRingCentralSDK();

export const integrationsMapping = {
  "Ring Central": {
    clientId: "attribute_1",
    clientSecret: "attribute_2",
    features: "attribute_3",
    countries: "attribute_4",
    type: "attribute_5",
    active: "active",
    integrationName: "attribute_6",
  },

  OpenAI: {
    apiKey: "attribute_1",
    type: "attribute_5",
    active: "active",
    integrationName: "attribute_6",
  },

  Whatsapp: {
    businessName: "attribute_1",
    accessToken: "attribute_2",
    webhookVerifyToken: "attribute_3",
    type: "attribute_5",
    active: "active",
    integrationName: "attribute_6",
  },
};